import { render, staticRenderFns } from "./BrazilVSlider.vue?vue&type=template&id=3c35c22e&"
import script from "./BrazilVSlider.vue?vue&type=script&lang=js&"
export * from "./BrazilVSlider.vue?vue&type=script&lang=js&"
import style0 from "./BrazilVSlider.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
